<eds-panel
  [enableHover]="false"
  [hasBorderRadius]="false"
  [hasBorders]="true"
  [hasPadding]="true"
  [hasShadows]="false"
  theme="white"
>
  <div edsGrid>
    <div edsRow>
      <div edsCol>
        <eds-section-header
          [title]="'products.52-week-range' | translate: fundId"
          [level]="3"
          [isLight]="true"
          theme="primary"
          size="h6"
          edsSpacing="md"
          caveatPlacement="Price:WeekRangePrice"
        ></eds-section-header>
      </div>
    </div>
    <div>
      <div edsCssCols edsSubGrid="layout-1" colGap="xxl">
        <eds-info-item
          *ngFor="let item of weeksData"
          [info]="item"
          edsSpacing="xs"
        ></eds-info-item>
      </div>
    </div>
  </div>
</eds-panel>
